import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { Visits, Visit, CreateVisit, UpdateVisit } from "./pages";

export const VisitsRouter = [
  <Route
    path="/visits"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Visits />
      </ProtectedRoute>
    }
  />,

  <Route path="/visit">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateVisit />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Visit />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateVisit />
        </ProtectedRoute>
      }
    />
  </Route>,
];
